import React, { Component } from 'react'

export default class Skill extends Component {
    componentDidMount() {
        window.$(".progress").each(function () {

            var value = window.$(this).attr('data-value');
            var left = window.$(this).find('.progress-left .progress-bar');
            var right = window.$(this).find('.progress-right .progress-bar');

            if (value > 0) {
                if (value <= 50) {
                    right.css('transform', 'rotate(' + percentageToDegrees(value) + 'deg)')
                } else {
                    right.css('transform', 'rotate(180deg)')
                    left.css('transform', 'rotate(' + percentageToDegrees(value - 50) + 'deg)')
                }
            }

        })

        function percentageToDegrees(percentage) {

            return percentage / 100 * 360

        }
    }
    render() {
        return (
            <>
                <h2 className="heading">Skills</h2>
                <span className="date" style={{ fontSize: "20px" }}><b>Program languages that I used recently</b></span>
                <div className="row progress-circle mb-5">
                    <div className="col-lg-4 mb-4">
                        <div className="bg-white rounded-lg shadow p-4">
                            <h2 className="h5 font-weight-bold text-center mb-4">CSS</h2>


                            <div className="progress mx-auto" data-value='90'>
                                <span className="progress-left">
                                    <span className="progress-bar border-primary"></span>
                                </span>
                                <span className="progress-right">
                                    <span className="progress-bar border-primary"></span>
                                </span>
                                <div
                                    className="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                    <div className="h2 font-weight-bold">90<sup className="small">%</sup></div>
                                </div>
                            </div>



                            <div className="row text-center mt-4">
                                <div className="col-6 border-right">
                                    <div className="h4 font-weight-bold mb-0">90%</div><span
                                        className="small text-gray">Last week</span>
                                </div>
                                <div className="col-6">
                                    <div className="h4 font-weight-bold mb-0">90%</div><span
                                        className="small text-gray">Last month</span>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-lg-4 mb-4">
                        <div className="bg-white rounded-lg shadow p-4">
                            <h2 className="h5 font-weight-bold text-center mb-4">HTML</h2>


                            <div className="progress mx-auto" data-value='90'>
                                <span className="progress-left">
                                    <span className="progress-bar border-primary"></span>
                                </span>
                                <span className="progress-right">
                                    <span className="progress-bar border-primary"></span>
                                </span>
                                <div
                                    className="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                    <div className="h2 font-weight-bold">90<sup className="small">%</sup></div>
                                </div>
                            </div>



                            <div className="row text-center mt-4">
                                <div className="col-6 border-right">
                                    <div className="h4 font-weight-bold mb-0">90%</div><span
                                        className="small text-gray">Last week</span>
                                </div>
                                <div className="col-6">
                                    <div className="h4 font-weight-bold mb-0">90%</div><span
                                        className="small text-gray">Last month</span>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-lg-4 mb-4">
                        <div className="bg-white rounded-lg shadow p-4">
                            <h2 className="h5 font-weight-bold text-center mb-4">ReactJs</h2>


                            <div className="progress mx-auto" data-value='90'>
                                <span className="progress-left">
                                    <span className="progress-bar border-primary"></span>
                                </span>
                                <span className="progress-right">
                                    <span className="progress-bar border-primary"></span>
                                </span>
                                <div
                                    className="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                    <div className="h2 font-weight-bold">90<sup className="small">%</sup></div>
                                </div>
                            </div>



                            <div className="row text-center mt-4">
                                <div className="col-6 border-right">
                                    <div className="h4 font-weight-bold mb-0">90%</div><span
                                        className="small text-gray">Last week</span>
                                </div>
                                <div className="col-6">
                                    <div className="h4 font-weight-bold mb-0">90%</div><span
                                        className="small text-gray">Last month</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <span className="date" style={{ fontSize: "20px" }}><b>Program languages that I experienced in the past</b></span>
                <div className="row" style={{ marginTop: "20px" }}>
                    <div className="col-md-6 animate-box">
                        <div className="progress-wrap ftco-animate">
                            <h3>C#</h3>
                            <div className="progress">
                                <div className="progress-bar color-1" role="progressbar" aria-valuenow="60"
                                    aria-valuemin="0" aria-valuemax="100" style={{ width: "60%" }}>
                                    <span>60%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 animate-box">
                        <div className="progress-wrap ftco-animate">
                            <h3>C++</h3>
                            <div className="progress">
                                <div className="progress-bar color-2" role="progressbar" aria-valuenow="80"
                                    aria-valuemin="0" aria-valuemax="100" style={{ width: "80%" }}>
                                    <span>80%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 animate-box">
                        <div className="progress-wrap ftco-animate">
                            <h3>JAVA</h3>
                            <div className="progress">
                                <div className="progress-bar color-3" role="progressbar" aria-valuenow="70"
                                    aria-valuemin="0" aria-valuemax="100" style={{ width: "70%" }}>
                                    <span>70%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 animate-box">
                        <div className="progress-wrap ftco-animate">
                            <h3>Android</h3>
                            <div className="progress">
                                <div className="progress-bar color-4" role="progressbar" aria-valuenow="40"
                                    aria-valuemin="0" aria-valuemax="100" style={{ width: "40%" }}>
                                    <span>40%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 animate-box">
                        <div className="progress-wrap ftco-animate">
                            <h3>ASP.NET</h3>
                            <div className="progress">
                                <div className="progress-bar color-5" role="progressbar" aria-valuenow="50"
                                    aria-valuemin="0" aria-valuemax="100" style={{ width: "50%" }}>
                                    <span>50%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 animate-box">
                        <div className="progress-wrap ftco-animate">
                            <h3>SQL</h3>
                            <div className="progress">
                                <div className="progress-bar color-6" role="progressbar" aria-valuenow="80"
                                    aria-valuemin="0" aria-valuemax="100" style={{ width: "80%" }}>
                                    <span>80%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 animate-box">
                        <div className="progress-wrap ftco-animate">
                            <h3>JSON</h3>
                            <div className="progress">
                                <div className="progress-bar color-6" role="progressbar" aria-valuenow="70"
                                    aria-valuemin="0" aria-valuemax="100" style={{ width: "70%" }}>
                                    <span>70%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
